import React, { Component } from 'react';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';


import CustomTableNew from '../CustomTableNew';

var respondent_progress_table_data_org_admin = [{
    name: 'EMAIL',
    key: 'respondent__email',
    linkActive: false,
    link: '',
},
{
    name: 'SHORT NAME',
    key: 'respondent__short_name',
    linkActive: false,
    link: '',
},
{
    name: 'RELATION',
    key: 'assessor_group__assessor_name',
    linkActive: false,
    link: '',
}, {
    name: 'PROGRESS',
    key: 'respondent_completed_count_total_questions',
    linkActive: false,
    link: '',
}]

var respondent_progress_table_data = [{
    name: 'EMAIL',
    key: 'respondent__email',
    linkActive: false,
    link: '',
},
{
    name: 'SHORT NAME',
    key: 'respondent__short_name',
    linkActive: false,
    link: '',
},
{
    name: 'Relation',
    key: 'assessor_group__assessor_name',
    linkActive: false,
    link: '',
}, {
    name: 'Progress',
    key: 'respondent_completed_count_total_questions',
    linkActive: false,
    link: '',
}, {
    name: 'Extreme Response',
    key: 'extreame_response',
    type: 'extreame_response',
    linkActive: false,
    link: '',
}]

class DetailsModal extends Component {

    constructor(props) {
        super(props);
        this.state = {
            modal: props.initialModalState,
            modalData: props.modalData,
            fade: true,
        };

        this.toggle = this.toggle.bind(this);
    }



    toggle() {
        this.setState({
            modal: !this.state.modal,

        }, () => {
            this.props.onChangeDataChange(this.state.modal)
        });


    }

    componentDidMount(prevProps) {
        let respondents = [...this.props.modalData]
        respondents.map(val => {
            val["respondent_completed_count_total_questions"] = `${val.respondent_completed_count}/${val.user_assessment__assessment_number_count}`
        })
        this.setState({
            respondents,

        })

    }



    render() {


        const { ismodalDetails } = this.props
        return (
            <div>

                <Modal isOpen={this.state.modal} toggle={this.toggle}

                    className={this.props.className} style={{ maxWidth: '600px' }} centered>
                    <ModalHeader toggle={this.toggle} className="bg-black text-white text-uppercase custom-header">
                        <div className="d-flex align-items-center justify-content-between w-100">
                            <span>RESPONDENT DETAILS</span>
                            <i
                                className={`fa ${this.state.isDownloading ? 'fa-spinner fa-spin' : 'fa-download'} cursor-pointer downloadEnable`}
                                onClick={(e) => {
                                    e.preventDefault();
                                    this.setState({ isDownloading: true });
                                    try {
                                        // Pass the entire modalData array
                                        this.props.onCSVDownload(this.state.modalData);
                                    } finally {
                                        this.setState({ isDownloading: false });
                                    }
                                }}
                            ></i>
                        </div>
                    </ModalHeader>
                    <ModalBody>
                        {
                            this.state.modalData !== '' &&
                                this.state.modalData.length !== 0 ?
                                <CustomTableNew
                                    data={this.state.modalData}
                                    columns={!localStorage.getItem('usertype').includes('organisation_admin') ? respondent_progress_table_data : respondent_progress_table_data_org_admin}
                                    showSlNo="false"
                                    detailsModal={ismodalDetails}
                                />
                                :
                                <p>This assessment has no respondents</p>

                        }


                    </ModalBody>

                </Modal>
            </div>
        );
    }
}


export default DetailsModal;


// WEBPACK FOOTER //
// ./src/_components/common/DetailsModal/index.jsx